import { guid } from "@buildwithflux/shared";
import { PcbNodeHelper } from "./pcbNodeHelper";
function cloneNode(node) {
    const clonedNode = {
        ...node,
        uid: guid(),
        childUids: [],
    };
    delete clonedNode["bakedRules"];
    delete clonedNode["flattenedRules"];
    return clonedNode;
}
/**
 * Clones the specified nodes and their descendants, updating their parent-child relationships.
 *
 * @param pcbNodes - All baked nodes from document service.
 * @param nodesToClone - A list of nodes to clone.
 * @param newParentNodeUid - The UID of the new parent node for the cloned nodes.
 * @param allClonedNodesMap - A map to store all cloned nodes, keyed by their UIDs. This is optional, and if not provided, a new map will be created and returned.
 */
export function cloneNodesAndDescendants(pcbNodes, nodesToClone, newParentNodeUid, allClonedNodesMap = {}) {
    const originalToClonedUidMap = {};
    for (const originalNode of nodesToClone) {
        const clonedNode = cloneNode(originalNode);
        if (newParentNodeUid) {
            clonedNode.parentUid = newParentNodeUid;
            const clonedParentNode = allClonedNodesMap[newParentNodeUid];
            if (clonedParentNode) {
                clonedParentNode.childUids.push(clonedNode.uid);
            }
        }
        allClonedNodesMap[clonedNode.uid] = clonedNode;
        originalToClonedUidMap[originalNode.uid] = clonedNode.uid;
        const childNodes = originalNode.childUids
            .map((childUid) => pcbNodes[childUid])
            .filter((childNode) => {
            if (!childNode) {
                return false;
            }
            if (PcbNodeHelper.isVirtualNode(childNode)) {
                return false;
            }
            return true;
        });
        cloneNodesAndDescendants(pcbNodes, childNodes, clonedNode.uid, allClonedNodesMap);
    }
    return {
        clonedNodes: allClonedNodesMap,
        originalToClonedUidMap,
    };
}
//# sourceMappingURL=clone.js.map